import React, { Component } from "react";
import { Auth } from "aws-amplify";

import {
    Form
} from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import "./Signup.css";

export default class Signup extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            email: "",
            password: "",
            confirmPassword: "",
            confirmationCode: "",
            newUser: null
        };
    }

    validateForm() {
        return (
            this.state.email.length > 0 &&
            this.state.password.length > 0 &&
            this.state.password === this.state.confirmPassword
        );
    }

    validateConfirmationForm() {
        return this.state.confirmationCode.length > 0;
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    // handleSubmit = async event => {
    //     event.preventDefault();

    //     this.setState({ isLoading: true });

    //     this.setState({ newUser: "test" });

    //     this.setState({ isLoading: false });
    // }

    handleSubmit = async event => {
        event.preventDefault();

        this.setState({ isLoading: true });

        try {
            const newUser = await Auth.signUp({
                username: this.state.email,
                password: this.state.password
            });
            this.setState({
                newUser
            });
        } catch (e) {
            console.log("Hubo un error", e)
            alert(e.message);
        }

        this.setState({ isLoading: false });
    }
    handleConfirmationSubmit = async event => {
        event.preventDefault();

        this.setState({ isLoading: true });

        try {
            console.log("Este es el nena");
            let nena = await Auth.confirmSignUp(this.state.email, this.state.confirmationCode);
            console.log("Se acaba de confirar el estado", nena);
            let signin = await Auth.signIn(this.state.email, this.state.password);
            console.log("Este es el sign in ", signin)
            this.props.userHasAuthenticated(true);
            this.props.history.push("/");
        } catch (e) {
            alert(e.message);
            this.setState({ isLoading: false });
        }
    }

    // handleConfirmationSubmit = async event => {
    //   event.preventDefault();

    //   this.setState({ isLoading: true });

    //   try {
    //     await Auth.confirmSignUp(this.state.email, this.state.confirmationCode);
    //     await Auth.signIn(this.state.email, this.state.password);

    //     this.props.userHasAuthenticated(true);
    //     this.props.history.push("/");
    //   } catch (e) {
    //     alert(e.message);
    //     this.setState({ isLoading: false });
    //   }
    // }




    // handleConfirmationSubmit = async event => {
    //     event.preventDefault();

    //     this.setState({ isLoading: true });
    // }

    renderConfirmationForm() {
        return (
            <Form onSubmit={this.handleConfirmationSubmit}>
                <Form.Group controlId="confirmationCode" bsSize="large">
                    <Form.Label>Confirmation Code</Form.Label>
                    <Form.Control
                        autoFocus
                        type="tel"
                        value={this.state.confirmationCode}
                        onChange={this.handleChange}
                    />
                    <span>Please check your email for the code.</span>
                </Form.Group>
                <LoaderButton
                    block
                    bsSize="large"
                    disabled={!this.validateConfirmationForm()}
                    type="submit"
                    isLoading={this.state.isLoading}
                    text="Verify"
                    loadingText="Verifying…"
                />
            </Form>
        );
    }

    renderForm() {
        return (
            <form onSubmit={this.handleSubmit}>
                <Form.Group controlId="email" bsSize="large">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                        autoFocus
                        type="email"
                        value={this.state.email}
                        onChange={this.handleChange}
                    />
                </Form.Group>
                <Form.Group controlId="password" bsSize="large">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        value={this.state.password}
                        onChange={this.handleChange}
                        type="password"
                    />
                </Form.Group>
                <Form.Group controlId="confirmPassword" bsSize="large">
                    <Form.Label>Confirm Password</Form.Label>
                    <Form.Control
                        value={this.state.confirmPassword}
                        onChange={this.handleChange}
                        type="password"
                    />
                </Form.Group>
                <LoaderButton
                    block
                    bsSize="large"
                    disabled={!this.validateForm()}
                    type="submit"
                    isLoading={this.state.isLoading}
                    text="Signup"
                    loadingText="Signing up…"
                />
            </form>
        );
    }

    render() {
        return (
            <div className="Signup">
                {this.state.newUser === null
                    ? this.renderForm()
                    : this.renderConfirmationForm()}
            </div>
        );
    }
}
